import photoCollageView from './photoCollageComponent.html';
import './photoCollageComponent.css';

export function photoCollageComponent() {
	return {
		bindings: {
			images: '<',
			layout: '<',
			label: '<',
			link: '<',
			tooltip: '<',
		},
		controllerAs: 'vm',
		controller: photoCollageComponentCtrl,
		template: photoCollageView,
	};
}

export class photoCollageComponentCtrl {
	constructor() {
		'ngInject';
		// no injections needed
	}

	$onInit() {
		if (this.layout === '3up') {
			this.boxes = [
				{
					geometry: 'fit-260x260',
					style: {
						position: 'absolute',
						width: '260px',
						height: '145px',
						top: 0,
						left: 0,
					},
				},
				{
					geometry: 'fit-127x127',
					style: {
						position: 'absolute',
						width: '127px',
						height: '70px',
						top: '151px',
						left: 0,
					},
				},
				{
					geometry: 'fit-127x127',
					style: {
						position: 'absolute',
						width: '127px',
						height: '70px',
						top: '151px',
						right: 0,
					},
				},
			];
		} else if (this.layout === '3up-pin') {
			this.boxes = [
				{
					geometry: 'fit-246x246',
					style: {
						position: 'absolute',
						width: '246px',
						height: '138px',
						top: '6px',
						left: '6px',
					},
				},
				{
					geometry: 'fit-120x120',
					style: {
						position: 'absolute',
						width: '120px',
						height: '67px',
						top: '150px',
						left: '6px',
					},
				},
				{
					geometry: 'fit-120x120',
					style: {
						position: 'absolute',
						width: '120px',
						height: '67px',
						top: '150px',
						right: '8px',
					},
				},
			];
		}
		this._buildBoxes();
	}

	_buildBoxes() {
		for (let i = 0; i < this.boxes.length; i++) {
			const box = this.boxes[i];
			const image = this.images[i];
			if (image) {
				box.class = 'collage-image';
				box.style.background = `url(${image.url}.${box.geometry}.jpg) no-repeat 50% 50% / cover`;
			} else {
				box.class = 'collage-placeholder';
				box.style.background = '#D8D8D8';
			}
		}
	}
}
